/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MirrorRound = [
  ["path", { d: "M10 6.6 8.6 8" }],
  ["path", { d: "M12 18v4" }],
  ["path", { d: "M15 7.5 9.5 13" }],
  ["path", { d: "M7 22h10" }],
  ["circle", { cx: "12", cy: "10", r: "8" }]
];

export { MirrorRound as default };
//# sourceMappingURL=mirror-round.js.map
